<template lang="pug">
#about
    section.banner.position-relative
        div.picture
            img.img-fluid.small(src="img/banner/banner_about_mobile.jpg" alt="banner-about nanya")
            img.img-fluid.big(src="img/banner/banner_about.jpg" alt="banner-about nanya")
        div.mask_banner
        div.breadcrumb_block
            b-container
                b-breadcrumb(:items="breadcrumb_items")
        div.banner_h1
            h1 關於南亞
    b-container.py-sm-5.slogan
        h1.text-center.font-weight-bolder.py-5.color_first 深耕台灣一甲子・品質規格得第一
    section
        b-container
            div.history
                b-row.mb-5.animate__fadeInUp.animate__animated.animate__slow
                    b-col(cols="12" md="3").text-center
                        b-img(src="img/about/nanya_1.png" )
                    b-col(cols="12" md="9" align-self="center")
                        P.text-justify 南亞塑膠公司成立於1958年，於1972年開始生產硬質膠布產品，專精硬質膠布生產50年，在開發能力、品質穩定度上為業界先驅。膠布為塑膠製作成膜狀製品，業界稱之為膠布，膠布又分成硬質膠布與軟質膠布兩種，硬質的應用主要在須要硬挺度的材料與包裝使用，而軟質透過加入塑化劑，讓膠布有更好的延展性及彈性，適用在車體廣告及製作成袋狀產品使用。
                b-row.menu.mb-5.wow.animate__fadeInUp.animate__animated.animate__slow
                    b-col(cols="12" md="3").text-center
                        b-img(src="img/about/nanya_2.png" )
                    b-col(cols="12" md="9" align-self="center")
                        P.text-justify 南亞提供的硬質膠布材料，以聚氯乙烯PVC(Polyvinyl Chloride)與聚對苯二甲酸乙二酯PET(Polyethylene Terephthalate)為主，產品主要應用在真空成型包裝、食品藥品包裝、卡片印刷、地板建材印刷及貼合等廣泛用途。
                b-row.menu.mb-5.wow.animate__fadeInUp.animate__animated.animate__slow
                    b-col(cols="12" md="3").text-center
                        b-img(src="img/about/nanya_3.png" )
                    b-col(cols="12" md="9" align-self="center")
                        P.text-justify 主要生產地為台灣、廣州、南通及德州，通過品質管理認證ISO9001，環境管理認證ISO14001，職工安全管理認證OHSAS18001、TOSHMS，美國食藥管理局FDA認證，以及TAF實驗室。
    section.py-5   
        b-container.philosophy.pb-0.pb-md-5
            b-row
                b-col(cols="12" md="6" data-wow-duration="2s").wow.animate_left.order-2.order-md-1
                    span.p-4.p-sm-5
                        h2.color_first 南亞經營理念
                        p.py-4.text-justify 本公司於塑膠領域上、中、下游布局完整，藉由多角化及垂直整合的豐富經驗及優勢，量產多項具競爭力之產品。配合局勢變動擬訂對策，適時調整產業結構，持續加強研發及拓展市場，努力追求全產全銷，提升差異化及高值化產品銷售佔比。
                            | 在經營方面全力拓展國內、外銷售市場，開發高值化及差異化產品，亦適時調整產銷配置、加強成本控管，整體營運在全體同仁的努力下展現具體成效，再加上轉投資公司所貢獻之投資收益大幅增加。
                            | 未來，本公司將持續研究開發新材質、新用途、符合環保潮流及高附加價值產品，拓展新的利基市場，創造公司穩健成長動能。
                b-col.pl-md-0(cols="12" md="6" align-self="center").wow.animate_right.order-1.order-md-2
                    b-img(src="img/about/fpg_chairman.jpg" fluid )
    section.future
        b-container
            div.mb-5.bgc_first
                div.position-relative
                    span
                        svg(viewBox="0 0 40 19" fill="#ffffff").quote.quote_before
                            path(d="M3.93925781,12.15 C1.31307281,11.1058542 1.38555833e-13,9.0808744 1.38555833e-13,6.075 C1.38555833e-13,4.30311614 0.672356558,2.84766195 2.01708984,1.70859375 C3.36182313,0.569525555 4.84100756,-1.77635684e-15 6.4546875,-1.77635684e-15 C8.28985293,-1.77635684e-15 9.79276758,0.66444648 10.9634766,1.99335938 C12.1341855,3.32227227 12.7195313,4.96756832 12.7195313,6.92929687 C12.7195313,10.5679869 9.93518409,14.5072054 4.36640625,18.7470703 L1.42382813,16.4689453 C2.62617789,14.7287022 3.46464606,13.2890682 3.93925781,12.15 Z" )
                            path(d="M30.9392578,12.15 C28.3130728,11.1058542 27,9.0808744 27,6.075 C27,4.30311614 27.6723566,2.84766195 29.0170898,1.70859375 C30.3618231,0.569525555 31.8410076,-1.77635684e-15 33.4546875,-1.77635684e-15 C35.2898529,-1.77635684e-15 36.7927676,0.66444648 37.9634766,1.99335938 C39.1341855,3.32227227 39.7195312,4.96756832 39.7195312,6.92929687 C39.7195312,10.5679869 36.9351841,14.5072054 31.3664062,18.7470703 L28.4238281,16.4689453 C29.6261779,14.7287022 30.4646461,13.2890682 30.9392578,12.15 Z")
                    h2.text-white 公司願景
                    p.text-white 在所從事的各項產業領域，強化國際化和多角化的布局，達到世界級規模，居於產業的全球領導地位，並繼續不斷的謀求深化及精化，因應世界性的變動局勢，確保企業的長遠穩定發展。
                    span
                        svg(viewBox="0 0 40 19" fill="#ffffff").quote.quote_after
                            path(d="M3.93925781,12.15 C1.31307281,11.1058542 1.38555833e-13,9.0808744 1.38555833e-13,6.075 C1.38555833e-13,4.30311614 0.672356558,2.84766195 2.01708984,1.70859375 C3.36182313,0.569525555 4.84100756,-1.77635684e-15 6.4546875,-1.77635684e-15 C8.28985293,-1.77635684e-15 9.79276758,0.66444648 10.9634766,1.99335938 C12.1341855,3.32227227 12.7195313,4.96756832 12.7195313,6.92929687 C12.7195313,10.5679869 9.93518409,14.5072054 4.36640625,18.7470703 L1.42382813,16.4689453 C2.62617789,14.7287022 3.46464606,13.2890682 3.93925781,12.15 Z" )
                            path(d="M30.9392578,12.15 C28.3130728,11.1058542 27,9.0808744 27,6.075 C27,4.30311614 27.6723566,2.84766195 29.0170898,1.70859375 C30.3618231,0.569525555 31.8410076,-1.77635684e-15 33.4546875,-1.77635684e-15 C35.2898529,-1.77635684e-15 36.7927676,0.66444648 37.9634766,1.99335938 C39.1341855,3.32227227 39.7195312,4.96756832 39.7195312,6.92929687 C39.7195312,10.5679869 36.9351841,14.5072054 31.3664062,18.7470703 L28.4238281,16.4689453 C29.6261779,14.7287022 30.4646461,13.2890682 30.9392578,12.15 Z")


</template>

<script>
export default {
    metaInfo: {
        title: '關於南亞-南亞硬質膠布',
        titleTemplate: '',
        meta: [
            { name: 'description', content: '深耕台灣五十年・品質規格得第一' },
            { name: 'Keywords', content: '南亞塑膠、硬質膠布、關於南亞。' },
            { name: 'og:title', content: '關於南亞-南亞硬質膠布' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com.tw/' },
            { name: 'og:description', content: '深耕台灣五十年・品質規格得第一' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com.tw/img/OGimage.jpg' },
        ],
    },
    data() {
        return {
            breadcrumb_items: [
                {
                    text: 'Home',
                    to: { name: 'App' }
                },
                {
                    text: '關於南亞',
                    active: true
                }
            ]
        }
    }
}
</script>

<style lang="sass">
.breadcrumb 
    background-color: transparent

.slogan
    h1
        @media all and ( max-width: 767px )
            font-size: 30px
        @media all and ( max-width: 576px )
            font-size: 20px
.history
    p
        line-height: 1.94
        letter-spacing: 0.96px
        padding-left: 5px
        padding-right: 5px
    img
        width: 100%
        @media all and ( max-width: 767px)
            width: 75%
            padding-bottom: 25px
            
.philosophy
    overflow: hidden
    .row
        div
            &:nth-child(1)
                padding-right: 0
                position: relative
                z-index: 10
                span
                    display: block
                    box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.5)
                    background-color: #fafafa
                    position: relative
                p
                    line-height: 1.94
                    letter-spacing: 0.96px
        @media all and ( max-width: 767px )
            div
                padding: 0
                span
                    margin: 0 20px -25px
                    top: -35px
                
.future 
    .bgc_first
        padding: 80px
    @media all and ( max-width: 991px )
        .container
            padding: 0
            .bgc_first
                padding: 50px 25px
        
.quote
    width: 42px
    height: 20px
    transform: rotate(180deg)
    position: absolute
.quote_before
    top: -30px
    left: 0
.quote_after
    bottom: -30px
    right: 16px
</style>